import {get, post, url} from '../utils/request';

class API {
    static test() {
    }

    static adminMe() {
        return get(url('/api/admin/me'))
    }

    static loginAdmin(email, password) {
        const data = {
            username: email,
            password: password,
        };
        return post(url('/api/admin/login'), data);
    }

    static adminGetCategories() {
        return get(url('/api/admin/services/categories'))
    }

    static adminCreateCategory(name) {
        const data = {
            name: name,
        };
        return post(url('/api/admin/services/categories/create'), data)
    }

    static adminEditCategory(categoryId, name) {
        const data = {
            category_id: categoryId,
            name: name
        };
        return post(url('/api/admin/services/categories/edit'), data)
    }

    static adminDeleteCategory(categoryId) {
        const data = {
            category_id: categoryId,
        };
        return post(url('/api/admin/services/categories/delete'), data)
    }

    static adminSaveCategoriesOrder(categoryIds) {
        const data = {
            category_ids: categoryIds,
        };
        return post(url('/api/admin/services/categories/order'), data)
    }


    static adminFullCategoryLoad(categoryId) {
        return get(url(`/api/admin/services/categories/${categoryId}`))
    }

    static adminGetSubCategories(categoryId) {
        return get(url(`/api/admin/services/categories/${categoryId}/subcategories/`))
    }

    static adminCreateSubCategory(categoryId, name) {
        const data = {
            category_id: categoryId,
            name: name,
        };
        return post(url('/api/admin/services/categories/subcategories/create'), data)
    }

    static adminEditSubCategory(subcategoryId, name) {
        const data = {
            subcategory_id: subcategoryId,
            name: name
        };
        return post(url('/api/admin/services/categories/subcategories/edit'), data)
    }

    static adminDeleteSubCategory(subcategoryId) {
        const data = {
            subcategory_id: subcategoryId,
        };
        return post(url('/api/admin/services/categories/subcategories/delete'), data)
    }

    static adminSaveSubCategoriesOrder(subcategoryIds) {
        const data = {
            subcategory_ids: subcategoryIds,
        };
        return post(url('/api/admin/services/categories/subcategories/order'), data)
    }

    static adminGetCategoryServices(categoryId) {
        return get(url(`/api/admin/services/categories/${categoryId}/services/`))
    }

    static adminSaveServices(categoryId, services) {
        const data = {
            category_id: categoryId,
            services: services
        };
        return post(url('/api/admin/services/categories/services/save'), data)
    }

    static adminFullSubCategoryLoad(categoryId, subcategoryId) {
        return get(url(`/api/admin/services/categories/${categoryId}/${subcategoryId}`))
    }

    static adminGetCategorySubcategoryServices(categoryId, subcategoryId) {
        return get(url(`/api/admin/services/categories/${categoryId}/subcategories/${subcategoryId}/services/`))
    }

    static adminSaveSubcategoryServices(categoryId, subcategoryId, services) {
        const data = {
            category_id: categoryId,
            subcategory_id: subcategoryId,
            services: services
        };
        return post(url('/api/admin/services/categories/subcategories/services/save'), data)
    }

    static adminGetEmployees() {
        return get(url('/api/admin/employees'))
    }

    static adminSaveEmployees(employees) {
        const data = {
            employees: employees
        };
        return post(url('/api/admin/employees/save'), data)
    }

    static adminGetVacancies() {
        return get(url('/api/admin/vacancies'))
    }

    static adminSaveVacancies(vacancies) {
        const data = {
            vacancies: vacancies
        };
        return post(url('/api/admin/vacancies/save'), data)
    }

    static adminGetFAQ() {
        return get(url('/api/admin/faq'))
    }

    static adminSaveFAQ(items) {
        const data = {
            items: items
        };
        return post(url('/api/admin/faq/save'), data)
    }

    static adminGetArticles() {
        return get(url('/api/admin/articles'))
    }

    static adminAddArticles() {
        return post(url('/api/admin/articles/add'))
    }

    static adminDeleteArticles(articleId) {
        return post(url(`/api/admin/articles/delete/${articleId}`))
    }

    static adminEditArticle(article) {
        return post(url('/api/admin/articles/edit'), article)
    }

    static adminEditPublishArticle(articleId, isHidden) {
        const data = {
            id: articleId,
            hidden: isHidden
        };
        return post(url('/api/admin/articles/edit/publish'), data)
    }

    static adminGetDocs() {
        return get(url('/api/admin/docs'))
    }

    static adminSaveDocs(items) {
        const data = {
            documents: items
        };
        return post(url('/api/admin/docs/save'), data)
    }

    static adminGetEmpDocs() {
        return get(url('/api/admin/empdocs'))
    }

    static adminSaveEmpDocs(items) {
        const data = {
            documents: items
        };
        return post(url('/api/admin/empdocs/save'), data)
    }

    static adminGetBanner() {
        return get(url('/api/admin/banner'))
    }

    static adminSaveBanner(banner) {
        return post(url('/api/admin/banner/save'), banner)
    }

     static adminGetUsers() {
        return get(url('/api/admin/users'))
    }

    static adminSaveUsers(items) {
        const data = {
            users: items
        };
        return post(url('/api/admin/users/save'), data)
    }

    static getMainPage() {
        return get(url('/api/main/page'))
    }

    static getServicesPage() {
        return get(url('/api/main/categories_services'))
    }

    static getFAQPage() {
        return get(url('/api/main/faq_all'))
    }

    static getEmployeesPage() {
        return get(url('/api/main/employees_all'))
    }

    static getVacanciesPage() {
        return get(url('/api/main/vacancies_all'))
    }

    static getDocsPage() {
        return get(url('/api/main/docs_all'))
    }

    static getEmpDocsPage() {
         return get(url('/api/main/empdocs_all'))
    }

    static getArticlesPage() {
        return get(url('/api/main/articles_all'))
    }

    static getArticlesArticlePage(articleId) {
        return get(url(`/api/main/articles/${articleId}`))
    }

    static getDocsShort() {
        return get(url('/api/main/docs_short'))
    }

    static postRequestCall(name, phone) {
        const data = {
            name: name,
            phone: phone
        };
        return post(url('/api/main/request'), data)
    }
}

export default API;